import { configuration } from '../configuration'
import { helpers, type PluginConfiguration } from '../helpers'
import { icons } from '../icons'

declare global {
  interface Window {
    EmbeddedSandbox: {
      new (options: {
        target: string
        initialEndpoint: string
        persistExplorerState?: boolean
        initialState?: {
          sharedHeaders?: Record<string, string>
        }
      }): { embeddedSandboxIFrameElement?: HTMLIFrameElement }
    }
  }
}

export const playground: PluginConfiguration = {
  name: 'Playground',
  id: 'playground',
  icon: icons.playground,
  extra: '',
  layout: {
    type: 'full',
    render: () => {
      const createHTMLElement = helpers.createHTMLElement({
        className: 'w-full h-full',
        id: 'fu-tools-playground-sandbox',
        attributes: { 'fu-tools-playground-init-state': '' },
      })
      return createHTMLElement.outerHTML
    },
  },
  render: () => playground.layout.render({}),
  init: () => {
    const element = document.querySelector('#fu-tools-playground-sandbox')
    if (!element) {
      return
    }

    const loadSandbox = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          return
        }

        observer.unobserve(element)

        const script = document.createElement('script')
        script.src =
          'https://embeddable-sandbox.cdn.apollographql.com/_latest/embeddable-sandbox.umd.production.min.js'
        script.async = true
        script.id = 'fu-tools-playground-script'
        script.onload = () => {
          if (typeof window.EmbeddedSandbox === 'undefined') {
            return
          }
          const sandbox = new window.EmbeddedSandbox({
            target: '#fu-tools-playground-sandbox',
            initialEndpoint: configuration.apiUrl,
            persistExplorerState: true,
            initialState: {
              sharedHeaders: {
                Authorization: `Bearer ${sessionStorage.getItem('jwt') ?? localStorage.getItem('jwt')}`,
                'x-region': localStorage.getItem('region') ?? '',
                ...((window.location.pathname.split('/')[1] ?? '').split('-').length === 5
                  ? { 'x-tenant': window.location.pathname.split('/')[1] }
                  : {}),
              },
            },
          })

          const iframe = sandbox?.embeddedSandboxIFrameElement
          if (!iframe) {
            return
          }
          const playgroundEmbedInitState = element.getAttribute('fu-tools-playground-init-state')
          if (playgroundEmbedInitState) {
            iframe.onload = () => {
              window.addEventListener(
                'message',
                event => {
                  if (event.data.name === 'ExplorerListeningForHandshake') {
                    iframe?.contentWindow?.postMessage(JSON.parse(playgroundEmbedInitState), '*')
                  }
                },
                false
              )
            }
          }
        }
        document.head.appendChild(script)
      })
    }

    const observer = new IntersectionObserver(loadSandbox)
    observer.observe(element)
  },
}
